<template>
  <div class="g-content customer">
    <!-- 标题 -->
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3 v-if="customerInfo">{{ customerInfo.name }}</h3>

        <a-button
          type="primary"
          @click="
            () => {
              $router.go(-1);
            }
          "
          icon="double-left"
        >
          {{ $t('com_btn_back') }}
        </a-button>
      </div>
    </div>

    <div class="g-content-main common-filter-main">
      <div class="customer-main" v-if="customerInfo">
        <div class="customer-base">
          <ul>
            <li class="logo">
              <ImageSlider :listData="customerInfo?.icons" style="width: 50%;" />
            </li>
            <li style="margin-bottom:20px;">
              <a-button
                type="primary"
                @click="showUpdate"
                icon="edit"
                v-auth.and="['auth_customer_edit']"
              >
                {{ $t('com_btn_edit') }}
              </a-button>
            </li>
            <li>
              <label>{{ $t('com_table_name') }}：</label>
              <p>{{ customerInfo.name }}</p>
            </li>
            <li>
              <label>{{ $t('com_table_code') }}：</label>
              <p>{{ customerInfo.code }}</p>
            </li>

            <li
              v-if="
                customerInfo.areaId &&
                  areaListObject[customerInfo.areaId] &&
                  areaListObject[customerInfo.regionId]
              "
            >
              <label>{{ $t('com_form_area_region_label') }}：</label>
              <p>
                <span>
                  {{ areaListObject[customerInfo.areaId].name }}
                  <span v-if="customerInfo.regionId">
                    ,{{ areaListObject[customerInfo.regionId].name }}
                  </span>
                </span>
              </p>
            </li>
            <li v-else>
              <label>{{ $t('com_form_area_region_label') }}：</label>
              <p>--</p>
            </li>
            <li>
              <label>{{ $t('customer_table_platform') }}：</label>
              <p>
                {{ customerInfo.root ? $t('com_table_yes') : $t('com_table_no') }}
              </p>
            </li>
            <li>
              <label>{{ $t('customer_table_read') }}：</label>
              <p>
                {{ customerInfo.readable ? $t('com_table_yes') : $t('com_table_no') }}
              </p>
            </li>

            <li>
              <label>{{ $t('com_table_disabled') }}：</label>
              <p>
                {{ customerInfo.disable ? $t('com_table_yes') : $t('com_table_no') }}
              </p>
            </li>

            <li>
              <label>{{ $t('com_table_contact') }}：</label>
              <p>{{ customerInfo.contactPerson || '--' }}</p>
            </li>
            <li>
              <label>{{ $t('com_table_telephone') }}：</label>
              <p>{{ customerInfo.contact || '--' }}</p>
            </li>

            <li>
              <label>{{ $t('com_table_address') }}：</label>
              <p>{{ customerInfo.address || '--' }}</p>
            </li>

            <li>
              <label>{{ $t('com_table_created_time') }}：</label>
              <p>{{ customerInfo.createTime | formatDate }}</p>
            </li>

            <li>
              <label>{{ $t('com_table_created_by') }}：</label>
              <p>{{ customerInfo.createBy }}</p>
            </li>
          </ul>
        </div>
        <div class="customer-right">
          <div class="title">
            <h2>
              {{ $t('customer_title_list') }}(<span>{{ (stationList || []).length }}</span>
              {{ $t('customer_title_items') }})
            </h2>
            <router-link
              :to="{
                name: 'SiteAdd',
                query: { customerId: customerInfo.customerId },
              }"
            >
            </router-link>
          </div>
          <a-table
            :columns="columns"
            :data-source="stationList"
            :pagination="false"
            :rowKey="(_text, index) => index"
            bordered
            style="width:100%;"
            size="small"
          >
            <template slot="time" slot-scope="text">
              <div>
                {{ text | formatDate }}
              </div>
            </template>

            <!-- 名称 -->
            <template slot="name" slot-scope="text, record">
              <router-link
                :to="{
                  name: 'SiteDetail',
                  params: { id: record.stationId },
                }"
                v-if="
                  (authList.includes('auth_site') &&
                    authList.includes('auth_site_detail') &&
                    authList.includes('auth_site_list')) ||
                    isSuperAdmin
                "
              >
                {{ text }}
              </router-link>
              <span v-else>
                {{ text }}
              </span>
            </template>
            <!-- 数量 -->
            <template slot="devNum" slot-scope="text, record">
              <router-link
                :to="{
                  name: 'DeviceList',
                  query: {
                    type: 'all',
                    siteId: record.stationId,
                    customerId: record.customerId,
                  },
                }"
                v-if="authList.includes('auth_device') && authList.includes('auth_device_list')"
              >
                {{ text }}
              </router-link>
              <span v-else>
                {{ text }}
              </span>
            </template>
          </a-table>
          <br />
          <br />
          <div class="title">
            <h2>
              {{ $t('customer_title_user') }}(<span>{{ (userList || []).length }}</span>
              {{ $t('customer_title_items') }})
            </h2>
          </div>
          <a-table
            :columns="userColumns"
            :data-source="userList"
            :pagination="false"
            :rowKey="(_text, index) => index"
            bordered
            style="width:100%; padding-bottom: 20px"
            size="small"
          >
            <!-- 用户名 -->
            <template slot="name" slot-scope="text, record">
              <router-link
                :to="`/manage/system/user/detail/${record.userId}`"
                v-if="
                  (authList.includes('auth_user') &&
                    authList.includes('auth_user_list') &&
                    authList.includes('auth_user_detail')) ||
                    isSuperAdmin
                "
              >
                {{ text }}
              </router-link>
              <span v-else>{{ text }}</span>
            </template>

            <template slot="createTime" slot-scope="text">
              <div>
                {{ text | formatDate }}
              </div>
            </template>
          </a-table>
        </div>
      </div>
      <Empty v-else />
    </div>
    <!-- 编辑/添加 Customer -->
    <Update ref="customerUpdate" :callback="getCustomerDetail" />
  </div>
</template>
<script>
import * as API from '@/api/system/customer';
import Config from '@/config';
import areaMixin from '@/mixins/area';
import Update from './update.vue';
import { mapGetters } from 'vuex';

export default {
  mixins: [areaMixin],
  components: {
    Update,
  },
  data() {
    return {
      Config,
      customerInfo: null,
      stationList: [],
      userList: [],

      columns: [
        {
          title: this.$t('site_table_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: this.$t('site_table_devices_number'),
          dataIndex: 'devNum',
          align: 'center',
          scopedSlots: { customRender: 'devNum' },
        },
        {
          title: this.$t('com_table_created_time'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'time' },
        },
      ],

      // 用户
      userColumns: [
        {
          title: this.$t('user_table_userName'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },

        {
          title: this.$t('customer_table_site_created'),
          dataIndex: 'stationTotal',
          align: 'center',
        },
        {
          title: this.$t('com_table_created_by'),
          dataIndex: 'createBy',
        },
        {
          title: this.$t('com_table_created_time'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
  },

  created() {
    this.getData();
  },
  methods: {
    // 获取表单数据
    getData() {
      const _list = [this.getAreaList(), this.getCustomerDetail(true)];
      Promise.all(_list).finally(() => {
        this.$store.commit('setPageLoading', false);
      });
    },

    getCustomerDetail(init) {
      if (!init) {
        this.$store.commit('setPageLoading', false);
      }
      let id;
      if (this.$route && this.$route.params && this.$route.params.id) {
        id = this.$route.params.id;
      }
      return API.CustomerDetail({ customerId: id })
        .then(res => {
          if (res.code === 0) {
            this.customerInfo = res.data.customerInfo;
            this.stationList = res.data.stationList || [];
            this.userList = res.data.userList || [];
          }
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
        });
    },

    // 编辑/添加
    showUpdate() {
      this.$refs.customerUpdate.show(this.customerInfo.customerId);
    },
  },
};
</script>
<style lang="less" scoped>
.customer {
  height: 100%;
  padding-top: 0;
  padding-bottom: 0;
  .customer-main {
    min-height: 100%;
    display: flex;
    .customer-base {
      width: 310px;
      border-right: #eee solid 1px;
      min-height: 100%;
      min-width: 200px;

      ul {
        width: 90%;
        padding: 20px 0;
        li {
          min-height: 35px;
          // font-size: 14px;
          margin-bottom: 5px;
          display: flex;
          flex-wrap: wrap;
          font-size: 14px;

          label {
            color: #888;
          }
          p {
            word-break: break-all;
            word-wrap: break-word;
            color: #333;
          }
          &.logo {
            margin-bottom: 20px;
            border: #f5f5f5 solid 1px;
            padding: 5px;
            border-radius: 5px;
            img {
              max-width: 100%;
              max-height: 150px;
              margin: 0 auto;
            }
          }
        }
      }
    }

    .customer-right {
      flex: 1;
      padding: 20px 0 20px 30px;
      position: relative;

      .title {
        display: flex;
        justify-content: space-between;
        h2 {
          display: flex;
          align-items: center;
          font-size: 16px;
          margin-bottom: 15px;
          span {
            color: #1838d9;
            padding: 0 5px;
          }

          &::before {
            content: ' ';
            width: 5px;
            height: 15px;
            background: #489fb5;
            border-radius: 10px;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>
